module.exports = __webpack_public_path__ + "static/media/socials-twitter-color.4d9060f1.svg";